import {
  AdminSubmissionsResponse,
  GetResultResponse,
  SubmitQuizResponse,
} from '../types';

async function handleResponse<T>(res: Response): Promise<T> {
  if (!res.ok) {
    const body = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error((body as { error?: string }).error ?? res.statusText);
  }
  return res.json() as Promise<T>;
}

export async function submitQuiz(
  name: string,
  email: string,
  answers: number[],
): Promise<SubmitQuizResponse> {
  const res = await fetch('/api/quiz/submit', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name, email, answers }),
  });
  return handleResponse<SubmitQuizResponse>(res);
}

export async function getResult(id: string): Promise<GetResultResponse> {
  const res = await fetch(`/api/quiz/result/${encodeURIComponent(id)}`);
  return handleResponse<GetResultResponse>(res);
}

export async function getAdminSubmissions(
  page = 1,
  pageSize = 50,
): Promise<AdminSubmissionsResponse> {
  const params = new URLSearchParams({
    page: String(page),
    pageSize: String(pageSize),
  });
  const res = await fetch(`/api/manage/submissions?${params.toString()}`);
  return handleResponse<AdminSubmissionsResponse>(res);
}
